export default __webpack_public_path__ + "static/media/logoUc.9d21e464.png";